import { createReducer, on } from '@ngrx/store';
import * as TaxClassActions from './tax-class.actions';
import { otcCatalog } from 'src/app/pages/orders/interfaces/oneTimeCustomer.interface';

export interface TaxClassState {
  response: otcCatalog[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: otcCatalog[] };
}

export const initialState: TaxClassState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const taxClassReducer = createReducer(
  initialState,
  on(TaxClassActions.loadTaxClass, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TaxClassActions.loadTaxClassSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(TaxClassActions.loadTaxClassFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TaxClassActions.loadTaxClassSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
